import { takeLatest } from 'redux-saga/effects';
import {
    ADD_OR_UPDATE_TEMPLATE_REQUEST,
} from '../../redux/modules/LabSettings/labTest-actions';
import { addOrUpdateTemplateWorker } from './labTemplateWorkerSaga';

export default function* addOrUpdateTemplateWatcher() {
    yield takeLatest(ADD_OR_UPDATE_TEMPLATE_REQUEST, addOrUpdateTemplateWorker);
}
